export const toWatts = (volts: number, amps: number) => amps * volts

export const toAmps = (volts: number, watts: number) => watts / volts